import {
    Component,
    Input,
    OnDestroy,
    OnInit,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TextareaComponent } from "@components/textarea/textarea.component";
import _ from "lodash";
import { Subject, takeUntil } from "rxjs";
import { Kontrakt } from "~app/features/virkeskop/models/kontrakt-models";
import { KontraktMediatorService } from "~app/features/virkeskop/services/kontrakt-mediator.service";

@Component({
    selector: "rask-kontrakt-anteckningskogsvard",
    templateUrl: "./kontrakt-anteckningskogsvard.component.html",
    styleUrl: "./kontrakt-anteckningskogsvard.component.scss",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TextareaComponent,
        FormsModule
    ]
})
export class KontraktAnteckningskogsvardComponent implements OnInit, OnDestroy {
    @Input() label = "Anteckning skogsvård";
    @Input() readonly = false;

    protected anteckningSkogsvard: string;
    protected kontrakt?: Kontrakt;

    private readonly destroy$ = new Subject<void>();
    private readonly kontraktMediatorService = inject(KontraktMediatorService);

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    ngOnInit(): void {
        this.kontraktMediatorService.kontrakt$
            .pipe(takeUntil(this.destroy$))
            .subscribe ({
                next: kontrakt => {
                    this.kontrakt = kontrakt;
                },
                error: () => {
                    // --
                }
            });
    }

    protected onChange() {
        if (!_.isNil(this.kontrakt.anteckningSkogsvard)) {
            this.kontraktMediatorService.updateKontrakt(this.kontrakt);
        }
    }
}
